import { SmartDmMeasurementParser } from './SmartDmMeasurementParser';
import type { ParsedData } from '../../../../interfaces/toolData';

/**
 * Parser for JAE Smart DM PULSE files
 * 
 * Handles drilling pulse measurements:
 * - Pulse (binary pulse signal data)
 * 
 * Note: PULSE files have a unique timestamp format with extra data
 * Example: "07/08/2025 12:42:11 0,0"
 */
export class SmartDmPulseParser {
  static parse(fileContent: string): ParsedData {
    const unitMappings = {
      'Pulse': 'binary'
    };
    
    return SmartDmMeasurementParser.parse(
      fileContent,
      'PULSE',
      'JAE_SMARTDM_PULSE',
      unitMappings
    );
  }
} 